export const GAID_URL = process.env.REACT_APP_GAID_URL || "https://linkzdata.com";

export const GAID_API_BASE_URL =
  process.env.REACT_APP_GAID_API_BASE_URL || "https://api.linkzdata.com";

export const GAID_API_URL =
  process.env.REACT_APP_GAID_API_URL || "https://api.linkzdata.com/api/v1";

export const GAID_GRAPHQL_URL =
  process.env.REACT_APP_GAID_GRAPHQL_URL || "https://api.linkzdata.com/graphql";
